// AUTO-GENERATED (gen_eggcalc_i18n.py). Egg-cost calculator, 22 languages.
export const EGGCALC_GEN = {
 "fr": {
  "slug": "calculateur-cout-production-oeuf",
  "title": "Calculateur du coût de production d'un œuf | Ma Petite Ferme",
  "metaDescription": "Calculez gratuitement le coût de production d'un œuf selon votre nombre de poules, le taux de ponte et le prix de l'aliment. Outil gratuit pour éleveurs.",
  "h1": "Calculateur du coût de production d'un œuf",
  "intro": "Estimez en quelques secondes le coût de revient d'un œuf de votre élevage. Ajustez le nombre de poules, le taux de ponte et vos coûts d'alimentation pour connaître votre prix de production.",
  "hens": "Nombre de poules pondeuses",
  "layRate": "Taux de ponte (%)",
  "feedPrice": "Prix de l'aliment (€/kg)",
  "feedPerHen": "Consommation par poule (g/jour)",
  "otherCosts": "Autres coûts par jour (€)",
  "resultTitle": "Coût de production estimé",
  "perEgg": "par œuf",
  "perDozen": "par douzaine",
  "eggsPerDay": "œufs par jour",
  "disclaimer": "Estimation indicative basée sur vos saisies (alimentation + autres coûts quotidiens). N'inclut pas l'amortissement du matériel ni la main-d'œuvre.",
  "ctaTitle": "Suivez vos coûts réels avec Ma Petite Ferme",
  "ctaText": "Enregistrez vos pontes, vos coûts et vos ventes pour connaître votre vraie rentabilité, œuf par œuf.",
  "ctaBtn": "Créer ma ferme gratuitement"
 },
 "en": {
  "slug": "egg-production-cost-calculator",
  "title": "Egg Production Cost Calculator | Ma Petite Ferme",
  "metaDescription": "Free egg production cost calculator: enter your flock size, laying rate and feed price to find out your cost per egg. Built for backyard farmers.",
  "h1": "Egg Production Cost Calculator",
  "intro": "Estimate the cost of producing each egg from your flock in just seconds. Adjust the number of hens, laying rate and feed costs to find out your real production price.",
  "hens": "Number of laying hens",
  "layRate": "Laying rate (%)",
  "feedPrice": "Feed price ($/kg)",
  "feedPerHen": "Feed per hen (g/day)",
  "otherCosts": "Other daily costs ($)",
  "resultTitle": "Estimated production cost",
  "perEgg": "per egg",
  "perDozen": "per dozen",
  "eggsPerDay": "eggs per day",
  "disclaimer": "Indicative estimate based on your inputs (feed + other daily costs). Does not include equipment depreciation or labour.",
  "ctaTitle": "Track your real costs with Ma Petite Ferme",
  "ctaText": "Log your egg production, costs and sales to know your true profitability, egg by egg.",
  "ctaBtn": "Create my farm for free"
 },
 "es": {
  "slug": "calculadora-costo-produccion-huevo",
  "title": "Calculadora del costo de producción de un huevo | Ma Petite Ferme",
  "metaDescription": "Calcula gratis el costo de producción de un huevo según tus gallinas, la tasa de postura y el precio del alimento. Herramienta gratuita para criadores.",
  "h1": "Calculadora del costo de producción de un huevo",
  "intro": "Estima en pocos segundos el costo de producción de un huevo en tu granja. Ajusta el número de gallinas, la tasa de postura y tus costos de alimentación para conocer tu precio de producción.",
  "hens": "Número de gallinas ponedoras",
  "layRate": "Tasa de postura (%)",
  "feedPrice": "Precio del alimento ($/kg)",
  "feedPerHen": "Consumo por gallina (g/día)",
  "otherCosts": "Otros costos por día ($)",
  "resultTitle": "Costo de producción estimado",
  "perEgg": "por huevo",
  "perDozen": "por docena",
  "eggsPerDay": "huevos por día",
  "disclaimer": "Estimación indicativa basada en tus datos (alimentación + otros costos diarios). No incluye la amortización del equipo ni la mano de obra.",
  "ctaTitle": "Lleva el control de tus costos reales con Ma Petite Ferme",
  "ctaText": "Registra tus posturas, tus costos y tus ventas para conocer tu verdadera rentabilidad, huevo por huevo.",
  "ctaBtn": "Crear mi granja gratis"
 },
 "it": {
  "slug": "calcolatore-costo-produzione-uovo",
  "title": "Calcolatore del costo di produzione di un uovo | Ma Petite Ferme",
  "metaDescription": "Calcola gratuitamente il costo di produzione di un uovo in base al numero di galline, al tasso di deposizione e al prezzo del mangime. Strumento gratuito.",
  "h1": "Calcolatore del costo di produzione di un uovo",
  "intro": "Stima in pochi secondi il costo di produzione di un uovo del tuo allevamento. Regola il numero di galline, il tasso di deposizione e i costi di alimentazione per conoscere il tuo prezzo di produzione.",
  "hens": "Numero di galline ovaiole",
  "layRate": "Tasso di deposizione (%)",
  "feedPrice": "Prezzo del mangime (€/kg)",
  "feedPerHen": "Consumo per gallina (g/giorno)",
  "otherCosts": "Altri costi al giorno (€)",
  "resultTitle": "Costo di produzione stimato",
  "perEgg": "per uovo",
  "perDozen": "per dozzina",
  "eggsPerDay": "uova al giorno",
  "disclaimer": "Stima indicativa basata sui dati inseriti (alimentazione + altri costi giornalieri). Non include l'ammortamento delle attrezzature né il costo della manodopera.",
  "ctaTitle": "Monitora i tuoi costi reali con Ma Petite Ferme",
  "ctaText": "Registra le deposizioni, i costi e le vendite per conoscere la tua vera redditività, uovo per uovo.",
  "ctaBtn": "Crea la mia fattoria gratuitamente"
 },
 "nl": {
  "slug": "calculator-productiekosten-ei",
  "title": "Calculator productiekosten per ei | Ma Petite Ferme",
  "metaDescription": "Bereken gratis de productiekosten van een ei op basis van uw aantal kippen, legpercentage en voerprijs. Gratis tool voor pluimveehouders.",
  "h1": "Calculator productiekosten per ei",
  "intro": "Bereken in enkele seconden de kostprijs van een ei uit uw kippenstal. Pas het aantal legkippen, het legpercentage en uw voerkosten aan om uw productieprijs te kennen.",
  "hens": "Aantal legkippen",
  "layRate": "Legpercentage (%)",
  "feedPrice": "Voerprijs (€/kg)",
  "feedPerHen": "Voerverbruik per kip (g/dag)",
  "otherCosts": "Overige kosten per dag (€)",
  "resultTitle": "Geschatte productiekosten",
  "perEgg": "per ei",
  "perDozen": "per dozijn",
  "eggsPerDay": "eieren per dag",
  "disclaimer": "Indicatieve schatting op basis van uw invoer (voer + overige dagelijkse kosten). Afschrijving van materiaal en arbeidskosten zijn niet inbegrepen.",
  "ctaTitle": "Volg uw werkelijke kosten met Ma Petite Ferme",
  "ctaText": "Registreer uw legcijfers, kosten en verkopen om uw echte rentabiliteit te kennen, ei per ei.",
  "ctaBtn": "Maak mijn boerderij gratis aan"
 },
 "sv": {
  "slug": "kalkylator-produktionskostnad-agg",
  "title": "Kalkylator för produktionskostnad per ägg | Ma Petite Ferme",
  "metaDescription": "Beräkna gratis produktionskostnaden per ägg utifrån antal höns, värpfrekvens och foderpris. Gratis verktyg för hönshållare.",
  "h1": "Kalkylator för produktionskostnad per ägg",
  "intro": "Uppskatta på några sekunder självkostnaden per ägg i ditt bestånd. Justera antal höns, värpfrekvens och foderkostnader för att ta reda på ditt produktionspris.",
  "hens": "Antal värphöns",
  "layRate": "Värpfrekvens (%)",
  "feedPrice": "Foderpris (kr/kg)",
  "feedPerHen": "Foderförbrukning per höna (g/dag)",
  "otherCosts": "Övriga kostnader per dag (kr)",
  "resultTitle": "Uppskattad produktionskostnad",
  "perEgg": "per ägg",
  "perDozen": "per dussin",
  "eggsPerDay": "ägg per dag",
  "disclaimer": "Vägledande uppskattning baserad på dina uppgifter (foder + övriga dagliga kostnader). Inkluderar inte avskrivning av utrustning eller arbetskostnad.",
  "ctaTitle": "Följ dina verkliga kostnader med Ma Petite Ferme",
  "ctaText": "Registrera dina ägg, kostnader och försäljning för att känna till din verkliga lönsamhet, ägg för ägg.",
  "ctaBtn": "Skapa min gård gratis"
 },
 "de": {
  "slug": "rechner-produktionskosten-ei",
  "title": "Rechner für die Produktionskosten eines Eis | Ma Petite Ferme",
  "metaDescription": "Berechnen Sie kostenlos die Produktionskosten eines Eis nach Hühnerzahl, Legerate und Futterpreis. Kostenloses Tool für Geflügelhalter.",
  "h1": "Rechner für die Produktionskosten eines Eis",
  "intro": "Ermitteln Sie in wenigen Sekunden den Selbstkostenpreis eines Eis aus Ihrer Haltung. Passen Sie die Anzahl der Legehennen, die Legerate und Ihre Futterkosten an, um Ihren Produktionspreis zu kennen.",
  "hens": "Anzahl der Legehennen",
  "layRate": "Legerate (%)",
  "feedPrice": "Futterpreis (€/kg)",
  "feedPerHen": "Verbrauch pro Henne (g/Tag)",
  "otherCosts": "Sonstige Kosten pro Tag (€)",
  "resultTitle": "Geschätzte Produktionskosten",
  "perEgg": "pro Ei",
  "perDozen": "pro Dutzend",
  "eggsPerDay": "Eier pro Tag",
  "disclaimer": "Richtwert auf Basis Ihrer Angaben (Futter + sonstige Tageskosten). Abschreibungen für Geräte und Arbeitsaufwand sind nicht enthalten.",
  "ctaTitle": "Behalten Sie Ihre tatsächlichen Kosten im Blick mit Ma Petite Ferme",
  "ctaText": "Erfassen Sie Ihre Legeleistung, Kosten und Verkäufe, um Ihre echte Rentabilität – Ei für Ei – zu kennen.",
  "ctaBtn": "Meine Hühnerhaltung kostenlos anlegen"
 },
 "da": {
  "slug": "beregner-produktionsomkostning-aeg",
  "title": "Beregner til produktionsomkostning pr. æg | Ma Petite Ferme",
  "metaDescription": "Beregn gratis produktionsomkostningen pr. æg ud fra antal høner, lægningsrate og foderpris. Gratis værktøj til hønseholdere.",
  "h1": "Beregner til produktionsomkostning pr. æg",
  "intro": "Estimer på få sekunder, hvad det koster at producere et æg i dit hønshold. Juster antal høner, lægningsrate og foderomkostninger for at kende din faktiske produktionspris.",
  "hens": "Antal lægehøner",
  "layRate": "Lægningsrate (%)",
  "feedPrice": "Foderpris (kr./kg)",
  "feedPerHen": "Forbrug pr. høne (g/dag)",
  "otherCosts": "Andre omkostninger pr. dag (kr.)",
  "resultTitle": "Estimeret produktionsomkostning",
  "perEgg": "pr. æg",
  "perDozen": "pr. dusin",
  "eggsPerDay": "æg pr. dag",
  "disclaimer": "Vejledende estimat baseret på dine indtastninger (foder + andre daglige omkostninger). Inkluderer ikke afskrivning på udstyr eller arbejdstid.",
  "ctaTitle": "Følg dine faktiske omkostninger med Ma Petite Ferme",
  "ctaText": "Registrer din ægproduktion, dine omkostninger og dit salg for at kende din reelle rentabilitet – æg for æg.",
  "ctaBtn": "Opret min gård gratis"
 },
 "bg": {
  "slug": "kalkulator-sebestojnost-yajce",
  "title": "Калкулатор за себестойност на яйце | Ma Petite Ferme",
  "metaDescription": "Изчислете безплатно себестойността на едно яйце според броя кокошки, носливостта и цената на фуража. Безплатен инструмент за животновъди.",
  "h1": "Калкулатор за себестойност на яйце",
  "intro": "Изчислете за секунди себестойността на едно яйце от вашия птицевъден обект. Задайте броя кокошки-носачки, процента на носливост и разходите за фураж, за да разберете вашата производствена цена.",
  "hens": "Брой кокошки-носачки",
  "layRate": "Процент на носливост (%)",
  "feedPrice": "Цена на фуража (лв./кг)",
  "feedPerHen": "Консумация на кокошка (г/ден)",
  "otherCosts": "Други разходи на ден (лв.)",
  "resultTitle": "Прогнозна себестойност",
  "perEgg": "на яйце",
  "perDozen": "на дузина",
  "eggsPerDay": "яйца на ден",
  "disclaimer": "Приблизителна оценка на база въведените данни (фураж + други дневни разходи). Не включва амортизация на оборудването и разходи за труд.",
  "ctaTitle": "Следете реалните си разходи с Ma Petite Ferme",
  "ctaText": "Записвайте снасянията, разходите и продажбите си, за да познавате истинската си рентабилност — яйце по яйце.",
  "ctaBtn": "Създайте фермата си безплатно"
 },
 "hr": {
  "slug": "kalkulator-troskova-proizvodnje-jaja",
  "title": "Kalkulator troškova proizvodnje jaja | Ma Petite Ferme",
  "metaDescription": "Izračunajte besplatno trošak proizvodnje jaja prema broju kokoši, stopi nesivosti i cijeni hrane. Besplatan alat za uzgajivače peradi.",
  "h1": "Kalkulator troškova proizvodnje jaja",
  "intro": "Procijenite za nekoliko sekundi cijenu koštanja jaja iz vašeg uzgoja. Prilagodite broj kokoši, stopu nesivosti i troškove hranidbe kako biste saznali svoju proizvodnu cijenu.",
  "hens": "Broj kokoši nesilica",
  "layRate": "Stopa nesivosti (%)",
  "feedPrice": "Cijena hrane (€/kg)",
  "feedPerHen": "Potrošnja po kokoši (g/dan)",
  "otherCosts": "Ostali troškovi po danu (€)",
  "resultTitle": "Procijenjeni trošak proizvodnje",
  "perEgg": "po jajetu",
  "perDozen": "po tucetu",
  "eggsPerDay": "jaja po danu",
  "disclaimer": "Okvirna procjena temeljena na vašim unosima (hranidba + ostali dnevni troškovi). Ne uključuje amortizaciju opreme ni troškove rada.",
  "ctaTitle": "Pratite svoje stvarne troškove uz Ma Petite Ferme",
  "ctaText": "Bilježite nesivost, troškove i prodaju kako biste saznali svoju pravu isplativost, jaje po jaje.",
  "ctaBtn": "Stvorite svoju farmu besplatno"
 },
 "fi": {
  "slug": "munan-tuotantokustannuslaskuri",
  "title": "Munan tuotantokustannuslaskuri | Ma Petite Ferme",
  "metaDescription": "Laske ilmaiseksi munan tuotantokustannus kanojen määrän, munintaprosentin ja rehun hinnan perusteella. Ilmainen työkalu kasvattajille.",
  "h1": "Munan tuotantokustannuslaskuri",
  "intro": "Arvioi muutamassa sekunnissa tilasi munan omakustannushinta. Säädä kanojen määrää, munintaprosenttia ja rehukustannuksia selvittääksesi tuotantohintasi.",
  "hens": "Munivien kanojen määrä",
  "layRate": "Munintaprosentti (%)",
  "feedPrice": "Rehun hinta (€/kg)",
  "feedPerHen": "Rehunkulutus per kana (g/vrk)",
  "otherCosts": "Muut kustannukset per päivä (€)",
  "resultTitle": "Arvioitu tuotantokustannus",
  "perEgg": "per muna",
  "perDozen": "per tusina",
  "eggsPerDay": "munaa päivässä",
  "disclaimer": "Suuntaa-antava arvio syöttämiesi tietojen perusteella (rehu + muut päivittäiset kulut). Ei sisällä kaluston poistoja eikä työvoimakustannuksia.",
  "ctaTitle": "Seuraa todellisia kustannuksiasi Ma Petite Ferme -sovelluksella",
  "ctaText": "Kirjaa munintasi, kustannuksesi ja myyntisi selvittääksesi todellisen kannattavuutesi muna munalta.",
  "ctaBtn": "Luo tilani ilmaiseksi"
 },
 "et": {
  "slug": "muna-tootmiskulu-kalkulaator",
  "title": "Muna tootmiskulu kalkulaator | Ma Petite Ferme",
  "metaDescription": "Arvuta tasuta oma muna tootmiskulu vastavalt kanade arvule, munemismäärale ja söödahindale. Tasuta tööriist kanakasvatajaile.",
  "h1": "Muna tootmiskulu kalkulaator",
  "intro": "Hinnake mõne sekundiga oma kanafarmi ühe muna omahinda. Kohandage kanade arvu, munemismäära ja söödakulusid, et teada saada oma tootmishind.",
  "hens": "Munevate kanade arv",
  "layRate": "Munemismäär (%)",
  "feedPrice": "Sööda hind (€/kg)",
  "feedPerHen": "Sööda tarbimine kana kohta (g/päev)",
  "otherCosts": "Muud kulud päevas (€)",
  "resultTitle": "Hinnanguline tootmiskulu",
  "perEgg": "muna kohta",
  "perDozen": "tosina kohta",
  "eggsPerDay": "muna päevas",
  "disclaimer": "Ligikaudne hinnang teie sisestatud andmete põhjal (sööt + muud igapäevased kulud). Ei sisalda seadmete amortisatsiooni ega tööjõukulusid.",
  "ctaTitle": "Jälgige oma tegelikke kulusid Ma Petite Ferme abil",
  "ctaText": "Salvestage oma munemisandmed, kulud ja müük, et teada saada oma tegelik kasumlikkus muna haaval.",
  "ctaBtn": "Loo oma farm tasuta"
 },
 "el": {
  "slug": "ypologistis-kostous-paragogis-avgou",
  "title": "Υπολογιστής κόστους παραγωγής αυγού | Ma Petite Ferme",
  "metaDescription": "Υπολογίστε δωρεάν το κόστος παραγωγής αυγού βάσει αριθμού κότων, ποσοστού ωοτοκίας και τιμής τροφής. Δωρεάν εργαλείο για κτηνοτρόφους.",
  "h1": "Υπολογιστής κόστους παραγωγής αυγού",
  "intro": "Υπολογίστε σε λίγα δευτερόλεπτα το κόστος παραγωγής ενός αυγού από τη δική σας εκτροφή. Προσαρμόστε τον αριθμό των κοτών, το ποσοστό ωοτοκίας και τα έξοδα διατροφής για να γνωρίζετε την τιμή παραγωγής σας.",
  "hens": "Αριθμός ωοτόκων κοτών",
  "layRate": "Ποσοστό ωοτοκίας (%)",
  "feedPrice": "Τιμή τροφής (€/kg)",
  "feedPerHen": "Κατανάλωση ανά κότα (g/ημέρα)",
  "otherCosts": "Άλλα έξοδα ανά ημέρα (€)",
  "resultTitle": "Εκτιμώμενο κόστος παραγωγής",
  "perEgg": "ανά αυγό",
  "perDozen": "ανά δωδεκάδα",
  "eggsPerDay": "αυγά ανά ημέρα",
  "disclaimer": "Ενδεικτική εκτίμηση βάσει των στοιχείων που εισαγάγατε (διατροφή + λοιπά ημερήσια έξοδα). Δεν περιλαμβάνει απόσβεση εξοπλισμού ούτε εργατικό κόστος.",
  "ctaTitle": "Παρακολουθήστε τα πραγματικά σας κόστη με το Ma Petite Ferme",
  "ctaText": "Καταγράψτε τις ωοτοκίες, τα έξοδα και τις πωλήσεις σας για να γνωρίζετε την πραγματική σας κερδοφορία, αυγό προς αυγό.",
  "ctaBtn": "Δημιουργήστε τη φάρμα μου δωρεάν"
 },
 "hu": {
  "slug": "tojas-termelesi-koltseg-kalkulator",
  "title": "Tojás termelési költség kalkulátor | Ma Petite Ferme",
  "metaDescription": "Számítsd ki ingyen egy tojás termelési költségét a tyúkok száma, a tojáshozam és a takarmányár alapján. Ingyenes eszköz tojótyúk-tartóknak.",
  "h1": "Tojás termelési költség kalkulátor",
  "intro": "Néhány másodperc alatt becsüld meg egy tojás önköltségi árát a saját állományodban. Állítsd be a tyúkok számát, a tojáshozamot és a takarmányköltséget, hogy megismerd a tényleges termelési árat.",
  "hens": "Tojótyúkok száma",
  "layRate": "Tojáshozam (%)",
  "feedPrice": "Takarmány ára (Ft/kg)",
  "feedPerHen": "Takarmányfogyasztás tyúkonként (g/nap)",
  "otherCosts": "Egyéb napi költségek (Ft)",
  "resultTitle": "Becsült termelési költség",
  "perEgg": "tojásonként",
  "perDozen": "tucat",
  "eggsPerDay": "tojás naponta",
  "disclaimer": "Tájékoztató jellegű becslés a megadott adatok alapján (takarmány + egyéb napi költségek). Nem tartalmazza az eszközök amortizációját és a munkaerőköltséget.",
  "ctaTitle": "Kövesd nyomon valós költségeidet a Ma Petite Ferme-mel",
  "ctaText": "Rögzítsd a tojáshozamot, a kiadásokat és az értékesítést, hogy tojásonként lásd a valódi jövedelmezőséget.",
  "ctaBtn": "Farmom létrehozása ingyen"
 },
 "pt": {
  "slug": "calculadora-custo-producao-ovo",
  "title": "Calculadora do custo de produção do ovo | Ma Petite Ferme",
  "metaDescription": "Calcule gratuitamente o custo de produção do ovo com base no número de galinhas, taxa de postura e preço da ração. Ferramenta grátis para criadores.",
  "h1": "Calculadora do custo de produção do ovo",
  "intro": "Estime em poucos segundos o custo de produção de cada ovo do seu plantel. Ajuste o número de galinhas, a taxa de postura e os custos com alimentação para conhecer o seu preço de produção.",
  "hens": "Número de galinhas poedeiras",
  "layRate": "Taxa de postura (%)",
  "feedPrice": "Preço da ração (R$/kg)",
  "feedPerHen": "Consumo por galinha (g/dia)",
  "otherCosts": "Outros custos por dia (R$)",
  "resultTitle": "Custo de produção estimado",
  "perEgg": "por ovo",
  "perDozen": "por dúzia",
  "eggsPerDay": "ovos por dia",
  "disclaimer": "Estimativa indicativa baseada nos dados inseridos (alimentação + outros custos diários). Não inclui depreciação de equipamentos nem mão de obra.",
  "ctaTitle": "Acompanhe seus custos reais com o Ma Petite Ferme",
  "ctaText": "Registre suas posturas, custos e vendas para conhecer a sua verdadeira rentabilidade, ovo por ovo.",
  "ctaBtn": "Criar minha granja gratuitamente"
 },
 "pl": {
  "slug": "kalkulator-kosztu-produkcji-jajka",
  "title": "Kalkulator kosztu produkcji jajka | Ma Petite Ferme",
  "metaDescription": "Oblicz bezplatnie koszt produkcji jajka wedlug liczby kur, wskaznika niesnosci i ceny paszy. Darmowe narzedzie dla hodowcow.",
  "h1": "Kalkulator kosztu produkcji jajka",
  "intro": "Oszacuj w kilka sekund koszt wytworzenia jajka w swojej hodowli. Dostosuj liczbe kur niosek, wskaznik niesnosci i koszty zywienia, aby poznac swoja cene produkcji.",
  "hens": "Liczba kur niosek",
  "layRate": "Wskaznik niesnosci (%)",
  "feedPrice": "Cena paszy (zl/kg)",
  "feedPerHen": "Zuzycie paszy na kure (g/dzien)",
  "otherCosts": "Pozostale koszty dzienne (zl)",
  "resultTitle": "Szacowany koszt produkcji",
  "perEgg": "za jajko",
  "perDozen": "za tuzin",
  "eggsPerDay": "jajek dziennie",
  "disclaimer": "Szacunek orientacyjny oparty na wprowadzonych danych (zywienie + pozostale koszty dzienne). Nie uwzglednia amortyzacji sprzetu ani kosztow pracy.",
  "ctaTitle": "Sledz swoje rzeczywiste koszty z Ma Petite Ferme",
  "ctaText": "Rejestruj zniesione jajka, koszty i sprzedaz, aby poznac swoja prawdziwa rentownosc - jajko po jajku.",
  "ctaBtn": "Zaloz swoja ferme bezplatnie"
 },
 "lv": {
  "slug": "olas-razosanas-izmaksu-kalkulators",
  "title": "Olas ražošanas izmaksu kalkulators | Ma Petite Ferme",
  "metaDescription": "Aprēķiniet vienas olas ražošanas izmaksas pēc vistu skaita, dēšanas intensitātes un barības cenas. Bezmaksas rīks putnu audzētājiem.",
  "h1": "Olas ražošanas izmaksu kalkulators",
  "intro": "Dažu sekunžu laikā novērtējiet vienas olas pašizmaksu jūsu saimniecībā. Pielāgojiet vistu skaitu, dēšanas intensitāti un barošanas izmaksas, lai uzzinātu savu ražošanas cenu.",
  "hens": "Dējējvistu skaits",
  "layRate": "Dēšanas intensitāte (%)",
  "feedPrice": "Barības cena (€/kg)",
  "feedPerHen": "Barības patēriņš uz vistu (g/dienā)",
  "otherCosts": "Citas izmaksas dienā (€)",
  "resultTitle": "Aprēķinātās ražošanas izmaksas",
  "perEgg": "par olu",
  "perDozen": "par duciti",
  "eggsPerDay": "olas dienā",
  "disclaimer": "Indikatīvs aprēķins, pamatojoties uz jūsu ievadītajiem datiem (barošana + citas ikdienas izmaksas). Neietver aprīkojuma nolietojumu vai darbaspēka izmaksas.",
  "ctaTitle": "Sekojiet savām reālajām izmaksām ar Ma Petite Ferme",
  "ctaText": "Reģistrējiet savus dēšanas rezultātus, izmaksas un pārdošanu, lai uzzinātu savu patieso rentabilitāti — olu pa olai.",
  "ctaBtn": "Izveidot savu saimniecību bez maksas"
 },
 "ro": {
  "slug": "calculator-cost-productie-ou",
  "title": "Calculator costul de productie al unui ou | Ma Petite Ferme",
  "metaDescription": "Calculeaza gratuit costul de productie al unui ou in functie de numarul de gaini, rata de ouat si pretul furajului. Instrument gratuit pentru crescatori.",
  "h1": "Calculator costul de productie al unui ou",
  "intro": "Estimati in cateva secunde costul de productie al unui ou din ferma dumneavoastra. Ajustati numarul de gaini, rata de ouat si costurile cu hrana pentru a cunoaste pretul de productie.",
  "hens": "Numarul de gaini ouatoare",
  "layRate": "Rata de ouat (%)",
  "feedPrice": "Pretul furajului (RON/kg)",
  "feedPerHen": "Consum pe gaina (g/zi)",
  "otherCosts": "Alte costuri pe zi (RON)",
  "resultTitle": "Cost de productie estimat",
  "perEgg": "per ou",
  "perDozen": "per duzina",
  "eggsPerDay": "oua pe zi",
  "disclaimer": "Estimare orientativa bazata pe datele introduse (hrana + alte costuri zilnice). Nu include amortizarea echipamentelor si nici manopera.",
  "ctaTitle": "Urmariti costurile reale cu Ma Petite Ferme",
  "ctaText": "Inregistrati pontele, costurile si vanzarile pentru a cunoaste rentabilitatea reala, ou cu ou.",
  "ctaBtn": "Creati-va ferma gratuit"
 },
 "lt": {
  "slug": "kainu-skaiciuokle-kiausiniai-vistos",
  "title": "Kiaušinio gamybos kaštų skaičiuoklė | Ma Petite Ferme",
  "metaDescription": "Apskaičiuokite kiaušinio gamybos savikainą pagal vištų skaičių, dėjimosi intensyvumą ir pašarų kainą. Nemokamas įrankis ūkininkams.",
  "h1": "Kiaušinio gamybos kaštų skaičiuoklė",
  "intro": "Per kelias sekundes apskaičiuokite vieno kiaušinio savikainą jūsų ūkyje. Sureguliuokite vištų skaičių, dėjimosi intensyvumą ir pašarų išlaidas, kad sužinotumėte savo gamybos kainą.",
  "hens": "Dedeklių vištų skaičius",
  "layRate": "Dėjimosi intensyvumas (%)",
  "feedPrice": "Pašaro kaina (€/kg)",
  "feedPerHen": "Pašaro suvartojimas vienai vištai (g/parą)",
  "otherCosts": "Kitos dienos išlaidos (€)",
  "resultTitle": "Apskaičiuota gamybos savikaina",
  "perEgg": "už kiaušinį",
  "perDozen": "už tuzinąą",
  "eggsPerDay": "kiaušinių per parą",
  "disclaimer": "Apytikslė sąmata pagal jūsų įvestus duomenis (pašarai ir kitos dienos išlaidos). Neįskaičiuotas įrangos nusidėvėjimas ir darbo sąnaudos.",
  "ctaTitle": "Sekite savo tikrąsias išlaidas su Ma Petite Ferme",
  "ctaText": "Registruokite dėjimąsi, išlaidas ir pardavimus, kad tiksliai žinotumėte kiekvieno kiaušinio pelningumą.",
  "ctaBtn": "Sukurti savo ūkį nemokamai"
 },
 "sk": {
  "slug": "kalkulator-nakladov-na-vyrobu-vajca",
  "title": "Kalkulátor nákladov na výrobu vajca | Ma Petite Ferme",
  "metaDescription": "Vypočítajte si zadarmo náklady na výrobu vajca podľa počtu sliepok, miery znášky a ceny krmiva. Bezplatný nástroj pre chovateľov.",
  "h1": "Kalkulátor nákladov na výrobu vajca",
  "intro": "Odhadnite za pár sekúnd vlastné náklady na výrobu vajca vo vašom chove. Upravte počet sliepok, mieru znášky a náklady na krmivo, aby ste zistili svoju výrobnú cenu.",
  "hens": "Počet nosníc",
  "layRate": "Miera znášky (%)",
  "feedPrice": "Cena krmiva (€/kg)",
  "feedPerHen": "Spotreba krmiva na sliepku (g/deň)",
  "otherCosts": "Ostatné náklady za deň (€)",
  "resultTitle": "Odhadované náklady na výrobu",
  "perEgg": "za vajce",
  "perDozen": "za tucet",
  "eggsPerDay": "vajec za deň",
  "disclaimer": "Orientačný odhad na základe vašich zadaných údajov (krmivo + ostatné denné náklady). Nezahŕňa odpisy zariadení ani náklady na pracovnú silu.",
  "ctaTitle": "Sledujte svoje skutočné náklady s Ma Petite Ferme",
  "ctaText": "Zaznamenávajte znášku, náklady aj predaje, aby ste poznali svoju skutočnú ziskovosť - vajce po vajci.",
  "ctaBtn": "Vytvoriť moju farmu zadarmo"
 },
 "sl": {
  "slug": "kalkulator-stroski-proizvodnje-jajca",
  "title": "Kalkulator stroška proizvodnje jajca | Ma Petite Ferme",
  "metaDescription": "Brezplačno izračunajte strošek proizvodnje jajca glede na število kokoši, nesnost in ceno krme. Brezplačno orodje za rejce.",
  "h1": "Kalkulator stroška proizvodnje jajca",
  "intro": "V nekaj sekundah ocenite lastno ceno jajca iz vaše reje. Prilagodite število kokoši, stopnjo nesnosti in stroške krme, da ugotovite svojo proizvodno ceno.",
  "hens": "Število nesnic",
  "layRate": "Stopnja nesnosti (%)",
  "feedPrice": "Cena krme (€/kg)",
  "feedPerHen": "Poraba na kokoš (g/dan)",
  "otherCosts": "Drugi stroški na dan (€)",
  "resultTitle": "Ocenjeni strošek proizvodnje",
  "perEgg": "na jajce",
  "perDozen": "na ducat",
  "eggsPerDay": "jajc na dan",
  "disclaimer": "Okvirna ocena na podlagi vaših vnosov (krma + drugi dnevni stroški). Ne vključuje amortizacije opreme niti stroškov dela.",
  "ctaTitle": "Spremljajte svoje dejanske stroške z Ma Petite Ferme",
  "ctaText": "Beležite nesnost, stroške in prodajo, da ugotovite svojo pravo donosnost – jajce za jajcem.",
  "ctaBtn": "Brezplačno ustvari svojo farmo"
 },
 "cs": {
  "slug": "kalkulacka-nakladu-na-vejce",
  "title": "Kalkulačka nákladů na výrobu vejce | Ma Petite Ferme",
  "metaDescription": "Zdarma spočítejte náklady na výrobu vejce podle počtu slepic, snášky a ceny krmiva. Bezplatný nástroj pro chovatele.",
  "h1": "Kalkulačka nákladů na výrobu vejce",
  "intro": "Odhadněte za pár sekund vlastní náklady na jedno vejce z vašeho chovu. Upravte počet nosnic, míru snášky a náklady na krmení, abyste zjistili svou výrobní cenu.",
  "hens": "Počet nosnic",
  "layRate": "Míra snášky (%)",
  "feedPrice": "Cena krmiva (Kč/kg)",
  "feedPerHen": "Spotřeba na slepici (g/den)",
  "otherCosts": "Ostatní náklady za den (Kč)",
  "resultTitle": "Odhadované výrobní náklady",
  "perEgg": "za vejce",
  "perDozen": "za tucet",
  "eggsPerDay": "vajec za den",
  "disclaimer": "Orientační odhad na základě zadaných údajů (krmivo + ostatní denní náklady). Nezahrnuje odpisy vybavení ani náklady na pracovní sílu.",
  "ctaTitle": "Sledujte skutečné náklady s Ma Petite Ferme",
  "ctaText": "Zaznamenávejte snášku, náklady i prodeje a zjistěte svou skutečnou ziskovost – vejce po vejci.",
  "ctaBtn": "Vytvořit farmu zdarma"
 }
};
